import React, { Component } from "react";
import LoadingPanel from "../../common/LoadingPanel";
import { toolsController } from "../../../controllers/tools.controller";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { dateConvert } from "../../common/Helpers";
import dropdownSkladFilterCell from "../../common/grid/dropdownSkladFilterCell";

const skladDropdownFilterCell = dropdownSkladFilterCell();

const skladFromNazovCell = (props) => {
    return <td>{props.dataItem.skladFromNazov}</td>;
};

const skladToNazovCell = (props) => {
    return <td>{props.dataItem.skladToNazov}</td>;
};

class ZoznamExpedovaneBalikyParcelDialogContent extends Component {
    state = {
        items: [],
        loading: true,
        sklady: [],
        selectedIdSklad: null,
        skip: 0,
        take: 100
    };

    constructor(props) {
        super(props);
        this.typingTimeout = null;
    }

    componentDidMount() {
        this.getItems();
    }

    refreshGrid = () => {
        this.getItems(this.state.filter);
    };

    getItems(filter) {
        this.setState({
            loading: true
        });
        toolsController.getOdoslanieBalikyExpedovaneParcelItems(filter).then((ajaxData) => {
            let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
            this.setState({
                items: data,
                loading: false
            });
        });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    };

    callSearch = (filter) => {
        this.setState({
            filter: filter
        });
        var getItemsCallback = () => {
            this.getItems(filter);
        };
        // Clears the previously set timer.
        clearTimeout(this.typingTimeout);
        // Reset the timer, to make the http call after 475MS (this.callSearch is a method which will call the search API. Don't forget to bind it in constructor.)
        this.typingTimeout = setTimeout(getItemsCallback, 800);
    };

    renderDialogContent() {
        return (
            <div id="ZoznamExpedovaneBalikyParcelDialog">
                <Grid
                    className="ZoznamExpedovaneBalikyParcelGrid"
                    data={this.state.items.slice(this.state.skip, this.state.take + this.state.skip)}
                    selectedField="selected"
                    skip={this.state.skip}
                    take={this.state.take}
                    total={this.state.items.length}
                    pageable={{
                        buttonCount: 10,
                        info: true,
                        type: "numeric",
                        pageSizes: [25, 50, 100],
                        previousNext: true
                    }}
                    onPageChange={this.pageChange}
                    filterable
                    filter={this.state.filter}
                    filterOperators={{
                        text: [{ text: "grid.filterContainsOperator", operator: "contains" }],
                        date: [{ text: "grid.filterEqOperator", operator: "eq" }],
                        numeric: [{ text: "grid.filterEqOperator", operator: "eq" }]
                    }}
                    onFilterChange={(e) => {
                        this.callSearch(e.filter);
                    }}>
                    <GridColumn field="idbalik" title="ID Balík" width="100px" />
                    <GridColumn field="iddodavka" title="ID Dodávka" width="100px" />
                    <GridColumn field="idexpedicia" title="ID Expedícia" width="100px" />
                    <GridColumn field="ciarovyKod" title="Čiarový kód" width="120px" />
                    <GridColumn field="parcelNumber" title="Parcel Number" width="100px" />
                    <GridColumn field="parcelId" title="Parcel ID" width="100px" />
                    <GridColumn field="skladFrom" title="Odosielateľ" cell={skladFromNazovCell} filterCell={skladDropdownFilterCell} />
                    <GridColumn field="skladTo" title="Príjemca" cell={skladToNazovCell} filterCell={skladDropdownFilterCell} />
                    <GridColumn field="zoznamTypTovaru" title="Typ" width="80px" filterable={false} />
                    <GridColumn field="sposobDopravy" title="Doprava" filterable={false} />
                    <GridColumn field="datumVytvorene" title="Vytvorené" filter="date" format="{0:d.M.yyyy H:mm}" width="150px" />
                    <GridColumn field="datumExpedovane" title="Expedované" filter="date" format="{0:d.M.yyyy H:mm}" width="150px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default ZoznamExpedovaneBalikyParcelDialogContent;



// WEBPACK FOOTER //
// ./src/components/views/Tools/ZoznamExpedovaneBalikyParcelDialogContent.js